import Inspector from './inspector';

export default ({ attributes, setAttributes }) => {
  const {
    margin,
    image,
    imagePosition,
    absolute,
    positionAbsolute,
    positionAbsoluteVertical,
    borderRadius,
  } = attributes;

  const staticDefaultImage = 'https://via.placeholder.com/200x50';

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <div
        className={`Image ${margin} ${imagePosition} ${
          absolute ? positionAbsolute : ''
        } ${absolute ? positionAbsoluteVertical : ''}`}
      >
        <figure className="Image__content">
          <img
            src={image.src || staticDefaultImage}
            style={{ borderRadius: `${borderRadius}px` }}
          />
        </figure>
      </div>
    </>
  );
};
